import { useState } from 'react';
import { TERMS_URL, PRIVACY_URL } from '@/config/urls';
import { Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client'; // Use imported client
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://app.callsparker.com/reset-password*',
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage('Check your email for a password reset link!');
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-muted/30 to-background p-4'>
      <div className='w-full max-w-md space-y-8'>
        {/* Logo and Header */}
        <div className='text-center space-y-4'>
          <div className='flex items-center justify-center'>
            <img
              src='/images/8e8b8d0c-2b0f-47d3-aed3-98e19c548c8d.png'
              alt='CallSparker'
              className='h-16'
            />
          </div>
          <p className='text-muted-foreground'>
            Power your B2B voice prospecting with AI
          </p>
        </div>
        {/* Request Password Reset Form */}

        <Card className='border-2'>
          <CardHeader className='space-y-1'>
            <CardTitle className='text-2xl font-semibold'>
              Forgot Password
            </CardTitle>
            <CardDescription>
              We'll send a 6-digit code to your email. Use it on the next screen to set a new password.
            </CardDescription>
          </CardHeader>
          <CardContent>
            {message && (
              <Alert variant='default' className='mb-4'>
                <AlertDescription>{message}</AlertDescription>
              </Alert>
            )}
            {error && (
              <Alert variant='destructive' className='mb-4'>
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            <form onSubmit={handleResetPassword} className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='email'>Email address</Label>
                <Input
                  id='email'
                  type='email'
                  placeholder='your@email.com'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className='h-11'
                />
              </div>
              <Button type='submit' className='w-full h-11'>
                Send Reset Code
              </Button>
            </form>
            <p className='text-center text-sm text-muted-foreground mt-4'>
              Remembered your password?&nbsp;
              <Link to='/login' className='text-blue-500 hover:underline'>
                Sign in
              </Link>
            </p>
          </CardContent>
        </Card>

        {/* Legal Links */}
        <p className='text-center text-xs text-muted-foreground'>
          By using this service, you agree to our{' '}
          <a
            href={TERMS_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='underline hover:text-foreground'
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href={PRIVACY_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='underline hover:text-foreground'
          >
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
